import TextField from "./TextField.vue"
import TextArea from "./TextArea.vue"
import SelectField from "./SelectField.vue"
import DateField from "./DateField.vue"
import TimeFiled from "./TimeFiled.vue"
import FacilityField from "./FacilityField.vue"
import UserField from "./UserField.vue"
import FileUploadWithPreview from "@/components/operationalSecurity/BuildForm/FileUploadWithPreview.vue"
import CheckboxField from "./CheckboxField.vue"
import UserListField from "./UserListField.vue"
import CommandField from "./CommandField.vue"
import RhUsers from "./RhUsers.vue"
import MailListField from "./MailListField.vue"
import RecipientsField from "./RecipientsField.vue"
import RegionField from "./RegionField.vue"
import TimestampField from "./TimestampField.vue"
import DeviceDocField from "./DeviceDocField.vue"
import SupplierField from "./SupplierField.vue"
import TechniciansField from "./TechniciansField.vue"

export default {
  text: TextField,
  text_answer: TextArea,
  select: SelectField,
  date: DateField,
  time: TimeFiled,
  facilities: FacilityField,
  users: UserField,
  files_section: FileUploadWithPreview,
  checkbox: CheckboxField,
  userList: UserListField,
  commands: CommandField,
  rhUsers: RhUsers,
  mailList: MailListField,
  recipient: RecipientsField,
  region: RegionField,
  timestamp: TimestampField,
  deviceDoc: DeviceDocField,
  supplier: SupplierField,
  technicians: TechniciansField
}